/** @format */

const getTimestampFromDate = input => {
  let newInput = input
    .split(' - ')
    .map(function(date) {
      return Date.parse(date) / 1000;
    })
    .join(' - ');
  return newInput;
};

export default getTimestampFromDate;
